module.exports = __webpack_public_path__ + "img/close.974599c2.svg";